import React, { Component } from 'react'
import styled from 'styled-components'
import { Input, Tooltip, Spin, Popconfirm, Button, Icon, Upload, Form } from 'antd'
import ReactTable from 'react-table'
import { filterCaseInsensitive } from '../../util'

const { TextArea } = Input
const FormItem = Form.Item

const FilesUploadContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  -webkit-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  -moz-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
`

const EditAttachmentContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  background-color: #eeeeee;
`
const EditAttachmentTitle = styled.h6`
  color: #fff;
`
const EditingFileContainer = styled.div`
  margin: 10px 0;
`

class Attachments extends Component {
  constructor(props) {
    super(props)
    this.state = {
      attachmentDetailsVisible: false
    }
  }

  uploadAttachment = uploadParam => {
    const formData = new FormData()

    formData.append('file', uploadParam.file)
    formData.append('type', 'vehicle')
    formData.append('created_by_id', this.props.userId)
    formData.append('updated_by_id', this.props.userId)
    formData.append('filename', uploadParam.file.name)
    formData.append('description', uploadParam.file.name)
    formData.append('vehicleId', this.props.currentId)

    this.props.uploadAttachment({
      formData: formData
    })
  }

  handleAttachmentRowClick = row => {
    this.setState({
      attachmentDetailsVisible: true,
      attachmentId: row.id,
      attachmentName: row.filename,
      attachmentDescription: row.description
    })
  }

  onDescriptionChange = e => {
    this.setState({
      attachmentDescription: e.target.value
    })
  }

  handleUpdateAttachmentDescription = () => {
    this.props.updateAttachmentDescription({
      description: this.state.attachmentDescription,
      attachmentId: this.state.attachmentId,
      vehicleId: this.props.currentId,
      userId: this.props.userId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  confirmAttachmentDelete = event => {
    this.props.deleteAttachment({
      attachmentId: this.state.attachmentId,
      vehicleId: this.props.currentId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  render() {
    const {
      attachmentList,
      loadingAttachments,
      uploadingAttachment,
      deletingAttachment
    } = this.props
    return (
      <FilesUploadContainer>
        <div className="row">
          <div className="col-md-6">
            <h5>
              <Icon type="file" /> Files
            </h5>
          </div>
          <div className="col-md-6 text-right">
            {uploadingAttachment && (
              <div className="text-success">
                <Icon type="loading" /> Uploading File(s)
              </div>
            )}
            {deletingAttachment && (
              <div className="text-danger">
                <Icon type="loading" /> Deleting File(s)
              </div>
            )}
          </div>
        </div>
        {attachmentList &&
          attachmentList.length > 0 && (
            <Spin spinning={loadingAttachments}>
              <ReactTable
                defaultPageSize={5}
                data={attachmentList}
                defaultFilterMethod={filterCaseInsensitive}
                getTrProps={(state, rowInfo, column, instance) => ({
                  onClick: e => this.handleAttachmentRowClick(rowInfo.original)
                })}
                columns={[
                  {
                    Header: 'Attached Files',
                    columns: [
                      {
                        Header: 'Filename',
                        id: 'filename',
                        accessor: 'filename',
                        Cell: d => (
                          <Tooltip title={d.original.filename}>{d.original.filename}</Tooltip>
                        )
                      },
                      {
                        Header: 'Description',
                        id: 'description',
                        accessor: 'description',
                        Cell: d => (
                          <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
                        )
                      },
                      {
                        Cell: row => (
                          <Tooltip placement="left" title="Open this file on a new window">
                            <a target="_blank" href={row.original.signedUrl}>
                              <Icon type="export" className="fontSize20" />
                            </a>
                          </Tooltip>
                        ),
                        maxWidth: 35
                      }
                    ]
                  }
                ]}
                defaultSorted={[
                  {
                    id: 'id',
                    desc: true
                  }
                ]}
                className="-striped -highlight"
              />
            </Spin>
          )}
        {this.state.attachmentDetailsVisible && (
          <EditAttachmentContainer>
            <EditAttachmentTitle>
              <Icon type="edit" /> Edit Attachment Area
            </EditAttachmentTitle>
            <div>
              <EditingFileContainer>
                <Icon type="file" /> {this.state.attachmentName}
              </EditingFileContainer>
            </div>
            <div className="row">
              <div className="col-md-10">
                <TextArea
                  placeholder="Describe the attachment..."
                  rows={4}
                  onChange={this.onDescriptionChange}
                  value={this.state.attachmentDescription}
                />
              </div>
            </div>
            <div className="d-flex flex-row mt-2">
              <Button onClick={this.handleUpdateAttachmentDescription}>
                <Icon type="save" /> OK
              </Button>{' '}
              <Popconfirm
                title="Are you sure you want to delete this attachment?"
                onConfirm={this.confirmAttachmentDelete}
                okText="Yes"
                cancelText="No"
              >
                <Button type="danger" icon="delete" className="ml-2">
                  {' '}
                  DELETE
                </Button>
              </Popconfirm>
            </div>
          </EditAttachmentContainer>
        )}
        <br />
        <FormItem label="Upload File(s)">
          <Upload name="file" customRequest={this.uploadAttachment}>
            <Button>
              <Icon type="upload" /> Upload
            </Button>
          </Upload>
        </FormItem>
      </FilesUploadContainer>
    )
  }
}

export default Attachments



// WEBPACK FOOTER //
// ./src/components/vehicles/Attachments.js